import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import DeleteIcon from "@mui/icons-material/Delete";
import AppText from "@/components/AppText";
import AppBox from "@/components/AppBox";

interface MailboxRow {
  mailbox: string;
  days_left: string | number;
}

interface MailboxesTableProps {
  tableRows: MailboxRow[];
  onDelete: (mailbox: string) => void;
}

const MailboxesTable: React.FC<MailboxesTableProps> = ({
  tableRows,
  onDelete,
}) => {
  const handleDelete = (mailbox: string) => {
    onDelete(mailbox);
  };

  return (
    <TableContainer
      component={Paper}
      className="shadow-md rounded-md overflow-hidden"
    >
      <Table aria-label="mailboxes table">
        {/* Table Header */}
        <TableHead>
          <TableRow className="bg-gray-100">
            <TableCell className="text-gray-600 font-semibold">Mailboxes</TableCell>
            <TableCell className="text-gray-600 font-semibold">
              Days to Expire
            </TableCell>
            <TableCell className="text-gray-600 font-semibold" align="right">
              Delete
            </TableCell>
          </TableRow>
        </TableHead>

        {/* Table Body */}
        <TableBody>
          {tableRows.length ? (
            tableRows.map((row) => (
              <TableRow
                key={row.mailbox}
                className="hover:bg-gray-50 transition"
              >
                {/* Mailbox */}
                <TableCell>{row.mailbox}</TableCell>

                {/* Days to Expire */}
                <TableCell>
                  <AppText
                    className={`${
                      row.days_left === "expired" || row.days_left === 1
                        ? "text-red-600"
                        : "text-black"
                    }`}
                  >
                    {row.days_left}
                  </AppText>
                </TableCell>

                {/* Actions */}
                <TableCell align="right">
                  <AppBox className="flex justify-end">
                    <DeleteIcon
                      className="text-red-600 cursor-pointer hover:text-red-800 transition"
                      onClick={() => handleDelete(row.mailbox)}
                    />
                  </AppBox>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={3} className="text-center py-4">
                <div className="text-gray-500">No results</div>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default MailboxesTable;